import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';

export type ShortcutsPopup = {
  isOpen: boolean;
};

const defaultState: ShortcutsPopup = {
  isOpen: false
};

export const toggleShortcutsPopup = createActionCreator(
  'SHORTCUTS_POPUP/TOGGLE',
  resolve => (state?: ShortcutsPopup['isOpen']) => resolve(state)
);

export const shortcutsPopup = createReducer(defaultState, handle => [
  handle(toggleShortcutsPopup, (state, { payload }) => ({ isOpen: payload || !state.isOpen }))
]);

export const isShortcutsPopupOpen = (state: AppState): boolean => state.shortcutsPopup.isOpen;
